import { Link } from "react-router-dom";
import ArrowLeftIcon from "assets/icons/ArrowLeftIcon";
import { useAppSelector } from "store/hooks";
import { getSettings } from "store/slices";
import { t } from "i18next";

export default function Support() {
  const { dir } = useAppSelector(getSettings);

  return (
    <div dir={dir}>
      <div
        className="w-full relative bg-[#EEA854] max-h-80 h-72 md:h-80  bg-cover bg-no-repeat bg-center"
        style={{
          backgroundImage: `url(${require("../../assets/images/support/career-header-bg.png")})`,
        }}
      >
        <div className="container pt-6 flex flex-col gap-y-28 h-full">
          <div className="flex items-center gap-4">
            <Link to="/">
              <ArrowLeftIcon
                className={`h-5 w-5 ${dir === "rtl" ? "rotate-180" : ""}`}
                fill="#004E99"
              />
            </Link>
            <p className="text-theme-blue text-3xl">nexme</p>
          </div>
            <h1 className="text-[#004E99] font-bold text-4xl">
              {t('needHelp')}
            </h1>
        </div>
      </div>
      {/* <div className="container">{renderTab()}</div> */}
    </div>
  );
}
